module.exports = __webpack_public_path__ + "img/sms-logo--mark.1a57002f.svg";